import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getProPoPending = createAsyncThunk('/prosafe/getProPoPending',
    async ({ formData }) => {
        try {
            const myurl = `${V_URL}/prosafe/pro-po-ledger`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: formData,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN'),
                },
            });

            const data = response.data;
            // console.log(data, "getProPoPending response");

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            toast.error(error.response.data.message);
            return error
        }
    })

const getProPoPendingSlice = createSlice({
    name: "getProPoPending",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getProPoPending.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProPoPending.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getProPoPending.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getProPoPendingSlice.reducer;